const TitleH1 = ({ children }) => {
    return <h1>{children}</h1>
}

export default TitleH1;